
import React from 'react';
import _ from 'lodash';
import { FrameClose, FrameModal, ModalContent, Actions } from '../../sharedStyles';
import OButton from '../../../../styled/components/button';
import { Icon } from 'semantic-ui-react';

/***
 * * SHARED DATA ACCEPT MODAL
 * 
 * @param buttons Array Objects
 * @param onClose Function
 * @param title String
 * @param subtitle String
 * @param description String 
 * @params @buttons { text, callback, options = { any button props } }
 * @description Modal to ask to the user to accept the biometric matrix data required for the adivsor
 */
export default function SimpleModal({ title = {}, subtitle = {}, description = {}, buttons = [], onClose, ...restProps }) {

    return (
        <FrameModal>
            <FrameClose>
                <Icon name="close" size="large" onClick={ onClose }/>
            </FrameClose>
            <ModalContent>
                {!_.isEmpty(title) && <p className={title.classes.join(" ")} >{title.text}</p>}
                {!_.isEmpty(subtitle) && <p className={subtitle.classes.join(" ")}>{subtitle.text}</p>}
                {!_.isEmpty(description) && <p className={description.classes.join(" ")} dangerouslySetInnerHTML={{__html: description.text }}></p>}
            </ModalContent>
            <Actions>
                    {
                        _.map(buttons, ({text, callback, options }, index) => (
                            <OButton key={index} type="button" {...options} onClick={ callback }><span>{text}</span></OButton>
                        ))
                    }
                </Actions>
        </FrameModal>
    )

}
